import { useState, useEffect } from 'react';

type TValue = string | boolean | Record<string, unknown>;

export const useLocalStorage = (key: string, initialValue?: TValue) => {
  const [state, setState] = useState(() => {
    if (typeof window === undefined) {
      return initialValue;
    }
    try {
      const local = localStorage.getItem(key);
      if (typeof local !== 'string') {
        localStorage.setItem(key, JSON.stringify(initialValue));
        return initialValue;
      } else {
        return JSON.parse(local);
      }
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    if (typeof window === undefined) {
      return;
    }
    try {
      localStorage.setItem(key, JSON.stringify(state));
    } catch {
      // Noop
    }
  }, [state]);

  return [state, setState];
};
